import React, { Component } from "react";
import { connect } from "react-redux";
import { deactivateOverlayAction } from "../../services/ui/overlay/actions";

import tracking from "../../utils/tracking";
import "./overlay.scss";

const mapStateToProps = state => ({
  active: state.overlay.active,
  activeId: state.overlay.activeId
});

class Overlay extends Component {
  state = { scrollPos: 0 };

  componentDidUpdate(prevProps) {
    let scrollPos = 0;
    // styling document.documentElement seems to trigger
    // security error in iOS
    const html = document.querySelector("html");

    if (prevProps.active && !this.props.active) {
      scrollPos = Math.abs(+html.style.top.split("px")[0]);
    }

    const currentScroll = window.scrollY;

    if (this.props.active && currentScroll === 0) {
      return;
    }

    html.style.top = this.props.active ? `${-currentScroll}px` : "";
    html.style.position = this.props.active ? "fixed" : "";

    if (prevProps.active && !this.props.active && scrollPos > 0) {
      window.scrollTo(0, scrollPos);
    }
  }

  render() {
    const { active, deactivateOverlayAction, id, activeId } = this.props;

    return (
      <div className="overlay">
        <div
          className={`overlay__background ${
            active && activeId === id ? "overlay__background--active" : ""
          }`}
        />
        <div
          className={`overlay__panel ${
            active && activeId === id ? "overlay__panel--active" : ""
          }`}
        >
          <div className="overlay__content">
            {!this.props.hideClose && (
              <button
                aria-label="Close Button X"
                className="overlay__close"
                onClick={() => {
                  tracking.event("customEvent", {
                    eventCategory: "Close Overlay",
                    eventAction: "click",
                    eventLabel: `${id}, source: ${
                      this.props.routeProps.location.pathname
                    }`
                  });

                  deactivateOverlayAction(id);
                }}
              >
                X
              </button>
            )}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  { deactivateOverlayAction }
)(Overlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/index.js